import { AdminSearch } from '~components/adminSearch/AdminSearch';

export function AdminSearchIndexPage() {
  return <AdminSearch />;
}
